import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import type { ReactNode } from 'react';

export interface ITestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  footer?: ReactNode;
}

const CARD_HEIGHT = 218;
const CARD_PADDING = '14px 38px 25px 28px';
const REVIEW_TO_ATTRIBUTION_GAP = 16;
const ATTRIBUTION_TO_DOTS_GAP = 17;
const DOTS_LEFT_INDENT = 12;

export const TestimonialCard = ({ quote, author, role, footer }: ITestimonialCardProps) => (
  <div
    style={{
      backgroundColor: colors.secondary[800],
      border: `1.5px solid ${colors.primary[400]}`,
      borderRadius: 6,
      padding: CARD_PADDING,
      height: CARD_HEIGHT,
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}
    data-testid="testimonial-card"
  >
    <div>
      <Typography
        as="span"
        aria-hidden
        bold
        style={{
          fontSize: 64,
          lineHeight: 0.2,
          color: colors.primary[300],
          display: 'block',
          marginTop: 32,
        }}
      >
        &ldquo;
      </Typography>
      <Typography italic color={colors.shades[0]} style={{ lineHeight: 1.4 }}>
        {quote}
      </Typography>
    </div>
    <div>
      <div style={{ marginTop: REVIEW_TO_ATTRIBUTION_GAP }}>
        <Typography color={colors.shades[0]}>
          <Typography as="span" bold color={colors.shades[0]}>
            - {author}{' '}
          </Typography>
          | {role}
        </Typography>
      </div>
      {footer && (
        <div style={{ marginTop: ATTRIBUTION_TO_DOTS_GAP, marginLeft: DOTS_LEFT_INDENT }}>
          {footer}
        </div>
      )}
    </div>
  </div>
);
